import { CardAccountDetailsStarIcon } from './CardAccountDetailsStarIcon';

/**
 * author: Michael Richins
 * id 951C68F1-876F-440E-A4D9-B724BB6D6181
 * name card-account-details-star
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-details-star.svg
 * tags
 * - Account / User 
 */
export const CardAccountDetailsFavoriteIcon = CardAccountDetailsStarIcon;
export default CardAccountDetailsFavoriteIcon